import React from "react";
import { Box, Typography } from "@mui/material";

export function PasswordStrengthBars({
  strength = 1,
  barColors = ['#dddddd', '#ef4836', '#f6b44d', '#2b90ef', '#25c281'],
  scoreWords = ['muito fraca', 'fraca', 'regular', 'boa', 'forte'],
}) {
  return (
    <Box display="flex" gap="10px">
      <Box display="flex" flexDirection="column" width="100%" gap="4px">
        <Box display="flex" flexDirection="row" width="100%" gap="1px">
          {scoreWords.map((_item, index) => (
            <Box
              key={index}
              sx={{
                backgroundColor: index <= (strength - 1) ? barColors[strength - 1] : barColors[0],
                height: '8px',
                width: '100%',
                borderRadius: '2px',
              }}
              style={{ backgroundColor: index <= (strength - 1) ? barColors[strength - 1] : barColors[0] }}
            />
          ))}
        </Box>
        {scoreWords[strength - 1] &&
          <Typography variant="body2" color="#717171" textAlign='right' fontSize="11px">
            {scoreWords[strength - 1]}
          </Typography>}
      </Box>

    </Box >
  );
}

